/**
@format
@flow
*/
import * as React from 'react';
import { Form as KrispyForm } from '@krispy/forms/web';
import { withAppManager } from '@ziynx/components/utilities';
import type { ManagedProps } from '@ziynx/flow-types/appManager';

type Props = $ReadOnly<{|
  /**
   * Form title
   */
  title?: string,

  /**
   * Form ID
   */
  formID: string,

  /**
   * Width, if any,
   * Default 100%
   */
  width?: string,

  /**
   * Title's bottom padding
   */
  headingPaddingBottom?: string | number,

  /**
   * Max width, if any,
   * Default 100%
   */
  maxWidth?: string,

  /**
   * Content of form ie. inputs
   */
  children: any,

  /**
   * Custom onSubmit function fired when form is submitted
   */
  onSubmit?: () => void,

  /**
   * Custom onChange function fired when form is changed
   */
  onChange?: () => void,

  /**
   * Enable autocomplete
   */
  autocomplete?: 'off' | 'on'
|}>;

/**
 * Form component that takes in inputs through children.
 */
const Form = (props: ManagedProps<Props>): React$Node => (
  <KrispyForm {...props} />
);

Form.defaultProps = {
  width: '688px',
  maxWidth: '688px',
  headingPaddingBottom: '48px',
  viewport: 'desktop',
  onChange: () => {},
  onSubmit: () => {},
};

export default (withAppManager(Form): React$ComponentType<
  React$Config<ManagedProps<Props>, typeof Form.defaultProps>>);
